export default __webpack_public_path__ + "static/media/eurolight.b748e277.png";